import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import type { SafeUrl } from '@angular/platform-browser';

import type { TellentAppsBrand } from '@core/tellent-types';
import type { IconName, IconSize } from '@core/user-interface-legacy';
import { IconComponent, TruncateComponent } from '@core/user-interface-legacy';

export type MainNavigationItemVariant = 'default' | TellentAppsBrand;
@Component({
  selector: 'rt-main-navigation-item',
  templateUrl: './main-navigation-item.component.html',
  styleUrls: ['./main-navigation-item.component.less'],
  host: {
    '[class.active]': 'isActive()',
    '[class.small]': 'size() === "small"',
    '[class.circle]': '!buttonText',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TruncateComponent, IconComponent],
})
export class MainNavigationItemComponent {
  public readonly isActive = input<boolean>(false);
  public readonly hoverEffect = input<boolean>(false);
  public readonly link = input<SafeUrl | string | null>(null);
  public readonly target = input<'_self' | '_blank' | null>('_blank');

  public readonly iconSize = input<IconSize>('small');

  public readonly size = input<'small' | 'large'>('large');

  public readonly type = input<MainNavigationItemVariant>('default');

  @Input() public icon: IconName;
  @Input() public rightIcon: IconName | undefined;
  @Input() public buttonText: string | undefined;
}
